<template>
    <div class="newPage">

        <div class="content">
            <!--方案配置-->
            <!--<breadcrumb></breadcrumb>-->
            <div style="padding: 20px">
                <el-row :gutter="10" class="mb8">
                    <el-col :span="1.5">
                        <el-button type="primary"
                                   icon="el-icon-plus"
                                   size="mini"
                                   @click="add">新增
                        </el-button>
                    </el-col>
                </el-row>

            </div>
            <div v-if="tableData.list">
                <el-table v-loading="loading"
                          :data="tableData.list"
                >


                    <el-table-column label="方案名称" align="center" prop="name"/>
                    <el-table-column label="开始时间" align="center" prop="startTime"/>
                    <el-table-column label="结束时间" align="center" prop="endTime"/>
                    <!--<el-table-column label="数据类型" align="center" prop="stations"/>-->
                    <!--<el-table-column label="展示类型" align="center" prop="stations"/>-->
                    <el-table-column label="方案类型" align="center" prop="stations">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.isOpen==0" type="danger">私有</el-tag>
                            <el-tag v-if="scope.row.isOpen==1" type="success">公开</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="站点" align="center" prop="stations"/>
                    <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                        <template slot-scope="scope">
                            <el-button
                                    size="mini"
                                    type="text"
                                    icon="el-icon-edit"
                                    @click="handleUpdate(scope.row,true)"
                            >详情
                            </el-button>
                            <template v-if="scope.row.isMe">
                                <el-button
                                        size="mini"
                                        type="text"
                                        icon="el-icon-edit"
                                        @click="handleUpdate(scope.row,false)"

                                >修改
                                </el-button>
                                <el-button
                                        size="mini"
                                        type="text"
                                        icon="el-icon-delete"
                                        @click="handleDelete(scope.row)"
                                >删除
                                </el-button>
                            </template>
                            <template v-if="!scope.row.apply">
                                <el-button
                                        size="mini"
                                        type="text"
                                        @click="handleUse(scope.row)"
                                >应用
                                </el-button>
                            </template>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <pagination
                    v-show="tableData.totalCount>0"
                    :total="tableData.totalCount"
                    :page.sync="queryParams.page"
                    :limit.sync="queryParams.pageSize"
                    @pagination="getList"
            />
        </div>


        <el-dialog title="方案配置" :visible.sync="open" width="80%" append-to-body>
            <el-form ref="form" :model="form" size="mini" :rules="rules" label-width="140px">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="方案名称" prop="name">
                            <el-input :disabled="disabled" size="mini" v-model="form.name" placeholder="请输入方案名称"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="开始日期" prop="startTime">
                            <el-date-picker
                                    :disabled="disabled"
                                    v-model="form.startTime"
                                    size="mini"
                                    type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="选择日期时间">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="结束日期" prop="endTime">
                            <el-date-picker
                                    :disabled="disabled"
                                    v-model="form.endTime"
                                    size="mini"
                                    type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="选择日期时间">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="数据类型" prop="type">
                            <el-radio-group v-model="form.type" :disabled="disabled">
                                <el-radio :label="0">原始</el-radio>
                                <el-radio :label="1">审核</el-radio>
                                <el-radio :label="2">全部</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>

                    <!--<el-col :span="24">-->
                    <!--<el-form-item label="展示类型" prop="rateType">-->
                    <!--<el-radio-group v-model="form.rateType" :disabled="disabled">-->
                    <!--<el-radio :label="1">污染物</el-radio>-->
                    <!--<el-radio :label="2">站点</el-radio>-->
                    <!--</el-radio-group>-->
                    <!--</el-form-item>-->
                    <!--</el-col>-->
                    <el-col :span="24">
                        <el-form-item label="方案类型" prop="isOpen">
                            <el-radio-group v-model="form.isOpen " :disabled="disabled">
                                <el-radio :label="0">私有</el-radio>
                                <el-radio :label="1">公开</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="小时数据完整性" prop="hourData">
                            <div class="text"> 小时数据完整性VOCS小时数据内缺失组分不超过
                                <el-input class="input" :disabled="disabled" size="mini" v-model="form.hourData"
                                          placeholder="小时数据完整性"/>
                                %
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="日数据完整性" prop="dayData">

                            <div class="text">日小时数据完整性大于
                                <el-input class="input" :disabled="disabled" size="mini" v-model="form.dayData"
                                          placeholder="日数据完整性"/>
                                小时
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="月数据完整性" prop="monthData">
                            <div class="text">月数据的完整性应不少于
                                <el-input class="input" :disabled="disabled" size="mini" v-model="form.monthData"
                                          placeholder="月数据完整性"/>
                                天
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="年数据完整性" prop="yearData">
                            <!--<el-input :disabled="disabled" size="mini" v-model="form.yearData" placeholder="请输入方案名称"/>-->
                            <div class="text">所有月数据均为有效数据</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="区域范围" prop="stations">
                            <el-checkbox-group v-model="form.stations" :disabled="disabled">
                                <div v-for="(item,index) in addressList" :key="index">
                                    <el-checkbox :label='item'>{{item}}</el-checkbox>
                                </div>
                            </el-checkbox-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="form.id">
                        <el-form-item label="边界值修改" prop="stations">
                            <el-button type="primary" @click="getBoundary">边界值修改</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm" v-if="!disabled">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>

        <el-dialog title="边界值管理" :visible.sync="BoundaryOpen" width="80%" append-to-body>
            <el-table v-loading="loading"
                      :data="BoundaryData"
            >
                <el-table-column label="污染物名称" align="center" prop="name"/>
                <el-table-column label="最小值" align="center" prop="min">
                    <template slot-scope="scope">
                        <el-input class="input" size="mini" v-model="scope.row.min"/>
                    </template>
                </el-table-column>
                <el-table-column label="最大值" align="center" prop="max">
                    <template slot-scope="scope">
                        <el-input class="input" size="mini" v-model="scope.row.max"/>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" class-name="small-padding fixed-width" v-if="!disabled">
                    <template slot-scope="scope">
                        <!--<el-button-->
                        <!--size="mini"-->
                        <!--type="text"-->
                        <!--icon="el-icon-edit"-->
                        <!--@click="handleBoundary(scope.row)"-->
                        <!--&gt;修改-->
                        <!--</el-button>-->
                        <el-button
                                size="mini"
                                type="text"
                                icon="el-icon-edit"
                                @click="handleBoundarySave(scope.row)"
                        >保存
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="BoundaryOpen = false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import url from "../../../utils/UrlApi"
    // import Breadcrumb from "../../../components/breadcrumb";

    let num100 = /^100$|^(\d|[1-9]\d)$/

    export default {
        name: "planConfig",
        components: {},
        data() {
            return {
                open: false,
                BoundaryOpen: false,
                disabled: true,
                loading: false,
                tableData: {
                    totalCount: 0
                },
                form: {
                    id: null,
                    startTime: null,
                    endTime: null,
                    type: null,
                    rateType: null,
                    stations: [],
                },
                queryParams: {
                    page: 1,
                    pageSize: 10
                },
                rules: {
                    name: [
                        {required: true, message: "方案名不能为空", trigger: "blur"}
                    ],
                    isOpen: [
                        {required: true, message: "方案类型不能为空", trigger: "change"}
                    ],
                    startTime: [
                        {required: true, message: "开始时间不能为空", trigger: "change"}
                    ],
                    endTime: [
                        {required: true, message: "结束时间不能为空", trigger: "change"}
                    ],
                    type: [
                        {required: true, message: "数据类型不能为空", trigger: "change"}
                    ],
                    rateType: [
                        {required: true, message: "展示类型不能为空", trigger: "change"}
                    ],
                    stations: [
                        {required: true, message: "站点不能为空", trigger: "change"}
                    ],
                    hourData: [
                        {required: false, message: "小时数据完整性 不能为空", trigger: "blur"},
                        {
                            validator: function (rule, value, callback) {
                                if (!value) {
                                    return callback()
                                }

                                if (num100.test(value)) {
                                    callback();
                                } else {
                                    callback(new Error('请输入0-100的数字'));
                                }
                            }, trigger: "blur"
                        }
                    ],
                    dayData: [
                        {required: false, message: "日数据完整性 不能为空", trigger: "blur"},
                        {
                            validator: function (rule, value, callback) {
                                if (!value) {
                                    return callback()
                                }
                                if (Number.isInteger(value)) {
                                    return callback(new Error('请输入数字'));
                                }

                                if (0 <= value && value <= 24) {
                                    callback();
                                } else {
                                    callback(new Error('请输入0-24的数字'));
                                }
                            }, trigger: "blur"
                        }
                    ],
                    monthData: [
                        {required: false, message: "月数据完整性 不能为空", trigger: "blur"},
                        {
                            validator: function (rule, value, callback) {
                                if (!value) {
                                    return callback()
                                }
                                if (Number.isInteger(value)) {
                                    return callback(new Error('请输入数字'));
                                }

                                if (0 <= value && value <= 30) {
                                    callback();
                                } else {
                                    callback(new Error('请输入0-30的数字'));
                                }
                            }, trigger: "blur"
                        }
                    ],
                    // yearData: [
                    //     {required: true, message: "年数据完整性 不能为空", trigger: "blur"}
                    // ],
                },
                addressList: [],
                BoundaryData: []
            }
        },
        mounted() {
            this.getvocList()
            this.getList()
        },
        methods: {
            restart() {
                this.form = {
                    id: null,
                    name: null,
                    startTime: null,
                    endTime: null,
                    type: null,
                    rateType: null,
                    stations: [],
                }
            },
            getList() {
                let data = this.queryParams
                this.$http.get(url.selectList, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        this.tableData = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            getvocList() {
                let data = {}
                this.$http.get(url.vocDataAddr, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        this.addressList = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            removetag(value) {
                console.log(value)
            },
            handleUpdate(row, disabled) {

                let data = {
                    id: row.id
                }
                this.$http.get(url.selectInfo, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        this.form = res.data.data;
                        this.form.stations = res.data.data.stations.split(',')
                        this.open = true;
                        this.disabled = disabled
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            handleDelete(row) {
                let self = this
                this.$confirm('确定要删除此条数据吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let data = {
                        id: row.id
                    }
                    self.$http.post(url.selectDelete, data).then(res => {
                        if (res.data.code === '200') {
                            self.$message.success('删除成功')
                            self.getList()
                        } else {
                            self.$message.error(res.data.message)
                        }
                    })
                }).catch(() => {

                });
            },

            handleUse(row) {
                let self = this
                // this.$confirm({
                //     title: '重要操作！',
                //     content: '确定要将此方案应用吗？',
                //     onOk() {
                //         let data = {
                //             id: row.id
                //         }
                //         self.$http.post(url.selectUse, data).then(res => {
                //             if (res.data.code === '200') {
                //                 self.$message.success('应用成功')
                //                 self.getList()
                //             } else {
                //                 self.$message.error(res.data.message)
                //             }
                //         })
                //     },
                //     onCancel() {
                //
                //     }
                // });

                this.$confirm('确定要将此方案应用吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let data = {
                        id: row.id
                    }
                    self.$http.post(url.selectUse, data).then(res => {
                        if (res.data.code === '200') {
                            self.$message.success('应用成功')
                            self.getList()
                        } else {
                            self.$message.error(res.data.message)
                        }
                    })
                }).catch(() => {

                });
            },
            submitForm() {
                this.$refs["form"].validate(valid => {
                    if (valid) {

                        let data = JSON.parse(JSON.stringify(this.form))
                        data.stations = this.form.stations.join()
                        if (this.form.id) {
                            // 修改
                            this.$http.post(url.selectUpdate, data).then(res => {
                                if (res.data.code === '200') {
                                    this.$message.success('修改成功')
                                    this.cancel()
                                } else {
                                    this.$message.error(res.data.message)
                                }
                            })
                        } else {
                            // 新增

                            this.$http.post(url.selectSave, data).then(res => {
                                if (res.data.code === '200') {
                                    this.$message.success('添加成功')
                                    this.cancel()
                                } else {
                                    this.$message.error(res.data.message)
                                }
                            })
                        }
                    }
                });
            },
            cancel() {

                this.getList()
                this.open = false
            },
            add() {
                this.restart()

                this.open = true
                this.disabled = false
            },
            getBoundary() {
                let data = {
                    id: this.form.id
                }
                this.$http.get(url.selectBorderInfo, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        this.BoundaryData = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
                this.BoundaryOpen = true
            },
            handleBoundarySave(row) {
                let data = row
                data.paraConfigId = this.form.id
                if (row.borderId) {
                    // 修改
                    this.$http.post(url.borderUpdate, data).then(res => {
                        if (res.data.code === '200') {
                            this.$message.success('修改成功')
                            this.getBoundary()
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                } else {
                    // 新增
                    this.$http.post(url.borderSave, data).then(res => {
                        if (res.data.code === '200') {
                            this.$message.success('添加成功')
                            this.getBoundary()
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .text {
        //display: flex;
        //align-content: center;
        font-size: 12px;
        input[type=text] {
            border: 1px solid #ddd;
            width: 40px;
            margin: 0 10px;
            border-radius: 6px;
            padding: 0 4px;
        }
        .input {
            width: 100px;
            margin: 0 10px;
            border-radius: 6px;
            padding: 0 4px;
        }
    }

    .input {
        width: 100px;
    }
</style>



